import React, { Component } from "react";
import { Link } from "react-router-dom";

import logo from "assets/images/logo.png";
import logoColors from "assets/images/logo_colors.png";

class Logo extends Component {
  render() {
    const { className, colors } = this.props;

    return (
      <Link to="/" className={"logo " + (className ? className : "")}>
        <img src={colors ? logoColors : logo} alt="CLB Logo" />
      </Link>
    );
  }
}

export default Logo;
